import axios from "axios";
import { WRAPPER_LAPP_URLS } from "./wrapperUrls";
import { DEV_AI_ENDPOINTS } from "./endPoints";

const CHATGPT_SEARCH_QUERY = async (payload) => {
  const { params } = payload;
  console.log("Params:", params);
  const promise = axios.get(
    `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.CHATGPT_SEARCH}`,
    {
      params: params,
    }
  );
  return promise;
};

const POST_A_QUESTION = async (UserId, Question) => {
  const promise = axios({
    method: "post",
    url: `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.POST_QUESTION}`,
    params: {
      UserId: UserId,
      Question: Question,
    },
  });
  return promise;
};

const GET_ALL_QUESTIONS = async () => {
  const promise = axios.get(
    `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.ALL_QUESTIONS}`,
    {
      params: null,
    }
  );
  return promise;
};

const GET_ANSWER_BY_QUESTION = async (QuestionId) => {
  const promise = axios.get(
    `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.ANSWERS_BY_QUESTION}`,
    {
      params: {
        QuestionId: QuestionId,
      },
    }
  );
  return promise;
};

const APPROVE_ANS = async (AnswerId, Approved) => {
  const promise = axios({
    method: "post",
    url: `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.APPROVE}`,
    params: {
      AnswerId: AnswerId,
      Approved: Approved,
    },
  });
  return promise;
};

const POST_ANS = async (UserId, QuestionId, Answer) => {
  console.log("CHECK:", UserId, Answer, QuestionId);
  const promise = axios({
    method: "post",
    url: `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.POST_ANSWER}`,
    params: {
      UserId: UserId,
      QuestionId:QuestionId,
      Answer: Answer
    },
  });
  return promise;
};

const GET_ALL_USERS = async () => {
  const promise = axios.get(
    `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.ALL_USERS}`,
    {
      params: null,
    }
  );
  return promise;
};

const GET_LANGUAGES_INFO = async () => {
  const promise = axios.get(
    `
  ${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.ALL_LANGUAGES}`,
    {
      params: null,
    }
  );
  return promise;
};

const LOG_IN = async (username, password) => {
  const promise = axios({
    method: "post",
    url: `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.LOGIN}`,
    data: {
      username: username,
      password: password,
    },
  });
  return promise;
};

const REGISTER_IN = async (body) => {
  const promise = axios({
    method: "post",
    url: `${WRAPPER_LAPP_URLS.DEVAI_URL}/${DEV_AI_ENDPOINTS.REGISTER}`,
    data: {
      username: body.username,
      email: body.email,
      password: body.password,
      firstName: body.firstName,
      lastName: body.lastName,
    },
  });
  return promise;
};

export {
  CHATGPT_SEARCH_QUERY,
  GET_ALL_USERS,
  GET_LANGUAGES_INFO,
  LOG_IN,
  REGISTER_IN,
  POST_A_QUESTION,
  GET_ALL_QUESTIONS,
  GET_ANSWER_BY_QUESTION,
  APPROVE_ANS,
  POST_ANS,
};
